import { render, staticRenderFns } from "./GameSlide.vue?vue&type=template&id=4d646e80&scoped=true"
import script from "./GameSlide.vue?vue&type=script&lang=js"
export * from "./GameSlide.vue?vue&type=script&lang=js"
import style0 from "./GameSlide.vue?vue&type=style&index=0&id=4d646e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d646e80",
  null
  
)

export default component.exports